import React, { useState } from 'react';
import Terminal from './Modules/Terminal';
import Header from './Modules/Header';
import Home from './Modules/Home';
import AboutMe from './Modules/AboutMe';
import Projects from './Modules/Projects';
import ContactForm from './Modules/ContactForm';
import './Styles/App.scss';

const MainContent = () => (
  <div className="main-content">
    {/* Your main content goes here */}
    <Header />
    <Home />
    <AboutMe />
    <Projects />
    <ContactForm />
  </div>
);

function App() {
  const [terminalFinished, setTerminalFinished] = useState(false);

  // Check which page we're on based on the current path or query parameters
  const currentPath = window.location.pathname;
  const urlParams = new URLSearchParams(window.location.search);
  const route = urlParams.get('route');

  const isTerminalPage =
    currentPath.includes('terminal') || route === 'terminal';

  if (isTerminalPage) {
    return (
      <div className="app">
        {!terminalFinished ? (
          <Terminal onFinish={() => setTerminalFinished(true)} />
        ) : (
          <MainContent />
        )}
      </div>
    );
  }

  // Default to main portfolio content
  return (
    <div className="app">
      <MainContent />
    </div>
  );
}

export default App;
